import { render, staticRenderFns } from "./TotalValuesWindow.vue?vue&type=template&id=5a765684&scoped=true&"
import script from "./TotalValuesWindow.vue?vue&type=script&lang=ts&"
export * from "./TotalValuesWindow.vue?vue&type=script&lang=ts&"
import style0 from "./TotalValuesWindow.vue?vue&type=style&index=0&id=5a765684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a765684",
  null
  
)

export default component.exports